import React, { useEffect, useRef,useContext } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const IOSSwitch = withStyles((theme) => ({
    root: {
      width: 42,
      height: 26,
      padding: 0,
      margin: theme.spacing(1),
    },
    switchBase: {
      padding: 1,
      '&$checked': {
        transform: 'translateX(16px)',
        color: theme.palette.common.white,
        '& + $track': {
          backgroundColor: '#52d869',
          opacity: 1,
          border: 'none',
        },
      },
      '&$focusVisible $thumb': {
        color: '#52d869',
        border: '6px solid #fff',
      },
    },
    thumb: {
      width: 24,
      height: 24,
    },
    track: {
      borderRadius: 26 / 2,
      border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: theme.palette.grey[50],
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
  }))(({ classes, ...props }) => {
    return (
      <Switch
        focusVisibleClassName={classes.focusVisible}
        disableRipple
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked,
        }}
        {...props}
      />
    );
});

const ToggleScenarios = props => {
    //details options
    const [loader, setLoader] = React.useState(false);
    const [anchorElDetailsMenu, setanchorElDetailsMenu] = React.useState(null);
    const openDetailsMenu = Boolean(anchorElDetailsMenu);
    
    const handleClickDetailsMenu = (event) => {
        setanchorElDetailsMenu(event.currentTarget);
    };
    const handleClickAway = () => {
      setanchorElDetailsMenu(null);
    }
    return (
        <React.Fragment>
            <IconButton
                        aria-label="more"
                        id="long-button"
                        aria-controls="long-menu"
                        aria-expanded={openDetailsMenu ? 'true' : undefined}
                        aria-haspopup="true"
                        onClick={handleClickDetailsMenu}
                        className='btn-scenarios'
                        disabled={loader}
                        style={props.polygonActive ? {right: '534px'} : null}
                      >
                       {!loader?<img src={require('../../assets/icons/map/toggle-layer.svg')} />
                       :<div className={'loader'}></div>}
                      </IconButton>
                      {
                        openDetailsMenu && 
                        <ClickAwayListener onClickAway={handleClickAway}>
                            <div className="scenario-actions">
                                <FormControlLabel
                                    control={<IOSSwitch checked={props.toggleScenariosLayer} onChange={(e) => props.handleToggleScenariosLayer(e.target.checked)} />}
                                    label="Show HCM planning layer"
                                />
                            </div>
                        </ClickAwayListener>
                      }
        </React.Fragment>
    )
}

export default ToggleScenarios;